const translation = {
  currentPlan: '当前套餐',
  upgradeBtn: {
    plain: '升级套餐',
    encourage: '立即升级',
    encourageShort: '升级',
  },
  viewBilling: '管理账单及订阅',
  buyPermissionDeniedTip: '请联系企业管理员订阅',
  plansCommon: {
    title: '选择适合您的套餐',
    yearlyTip: '订阅年度计划可免费获得 2个月！',
    mostPopular: '最受欢迎',
    planRange: {
      monthly: '按月',
      yearly: '按年',
    },
    month: '月',
    year: '年',
    save: '节省',
    currentPlan: '当前计划',
    contractSales: '联系销售',
    contractOwner: '联系团队管理员',
    free: '免费',
    startForFree: '免费开始',
    getStartedWith: '开始使用',
    contactSales: '联系销售',
    talkToSales: '联系销售',
    modelProviders: '支持的模型提供商',
    teamMembers: '团队成员',
    buildApps: '构建应用程序数',
    annotationQuota: '标注回复数',
    vectorSpace: '向量空间',
    vectorSpaceTooltip: '向量空间是 LLMs 理解您的数据所需的长期记忆系统。',
    vectorSpaceBillingTooltip:
      '向量存储是将知识库向量化处理后为让 LLMs 理解数据而使用的长期记忆存储，1MB 大约能满足1.2 million character 的向量化后数据存储（以 OpenAI Embedding 模型估算，不同模型计算方式有差异）。在向量化过程中，实际的压缩或尺寸减小取决于内容的复杂性和冗余性。',
    documentsUploadQuota: '文档上传配额',
    documentProcessingPriority: '文档处理优先级',
    documentProcessingPriorityTip: '如需更高的文档处理优先级，请升级您的套餐',
    documentProcessingPriorityUpgrade:
      '以更快的速度、更高的精度处理更多的数据。',
    priority: {
      standard: '标准',
      priority: '优先',
      'top-priority': '最高优先级',
    },
    logsHistory: '日志历史',
    customTools: '自定义工具',
    unavailable: '不可用',
    days: '天',
    unlimited: '无限制',
    support: '支持',
    supportItems: {
      communityForums: '社区论坛',
      emailSupport: '电子邮件支持',
      priorityEmail: '优先电子邮件和聊天支持',
      logoChange: 'Logo更改',
      SSOAuthentication: 'SSO 认证',
      personalizedSupport: '个性化支持',
      dedicatedAPISupport: '专用 API 支持',
      customIntegration: '自定义集成和支持',
      ragAPIRequest: 'RAG API 请求',
      bulkUpload: '批量上传文档',
      agentMode: '代理模式',
      workflow: '工作流',
      llmLoadingBalancing: 'LLM 负载均衡',
      llmLoadingBalancingTooltip:
        '向模型添加多个 API 密钥，有效绕过 API 速率限制。',
    },
    comingSoon: '即将推出',
    member: '成员',
    memberAfter: '个成员',
    messageRequest: {
      title: '消息额度',
      tooltip: '为不同方案提供基于 OpenAI 模型的消息响应额度。',
    },
    annotatedResponse: {
      title: '标注回复数',
      tooltip:
        '标注回复功能通过人工编辑标注为应用提供了可定制的高质量问答回复能力',
    },
    ragAPIRequestTooltip: '指单独调用 Dify 知识库数据处理能力的 API。',
    receiptInfo: '只有团队所有者和团队管理员才能订阅和查看账单信息',
  },
  plans: {
    sandbox: {
      name: 'Sandbox',
      description: '200次 GPT 免费试用',
      includesTitle: '包括：',
    },
    professional: {
      name: 'Professional',
      description: '让个人和小团队能够以经济实惠的方式释放更多能力。',
      includesTitle: 'Sandbox 计划中的一切，加上：',
    },
    team: {
      name: 'Team',
      description: '协作无限制并享受顶级性能。',
      includesTitle: 'Professional 计划中的一切，加上：',
    },
    enterprise: {
      name: 'Enterprise',
      description: '获得大规模关键任务系统的完整功能和支持。',
      includesTitle: 'Team 计划中的一切，加上：',
    },
  },
  vectorSpace: {
    fullTip: '向量空间已满。',
    fullSolution: '升级您的套餐以获得更多空间。',
  },
  apps: {
    fullTipLine1: '升级您的套餐以',
    fullTipLine2: '构建更多的程序。',
  },
  annotatedResponse: {
    fullTipLine1: '升级您的套餐以',
    fullTipLine2: '标注更多对话。',
    quotaTitle: '标注的配额',
  },
  payment: {
    method: '支付方式',
    channel: '充值方式',
    alipay: '支付宝',
    confirmPay: '确认支付',
    cancelOrder: '取消订单',
    balancePay: '余额支付',
  },
  bill: {
    label: {
      availableQuota: '可用额度',
      billingPeriod: '账期',
    },
  },
  fee: {
    orderId: '订单号',
    type: '类型',
    status: '状态',
    amount: '金额',
    product: '产品',
    createdAt: '创建时间',
    paidAt: '支付时间',
    action: '操作',
    detail: '详情',
    orderSummary: '订单摘要',
    orderType: '订单类型',
    name: '名称',
    architecture: '架构',
    preferRegion: '首选区域',
    preferZone: '首选可用区',
    createOrder: '创建订单',
    onlineRecharge: '在线充值',
    rechargeAmount: '充值金额',
    inputRechargeAmount: '请输入充值金额',
    rechargeAmountGreaterThanZero: '充值金额需大于0',
    readAndCheck: '请阅读下列提示并勾选此项',
    iHaveRead: '我已阅读',
    createRechargeOrder: '创建充值订单',
    orderTagType: {},
    invoiceStatus: {},
    monthlyPaid: '月付费',
    annualPaid: '年付费',
    confirm: '确认',
    cancel: '取消',
    date: '日期',
    ioIn: '收入',
    ioOut: '支出',
    resourceId: '资源ID',
    resourceType: '资源类型',
    resourceName: '资源名称',
  },
  menu: {
    fee: '费用',
  },
  accountOverview: {
    title: '账户总览',
    availableBalance: '账户可用额度',
    availableBalanceTip:
      '可用余额为负数时，资源可能会被关停，为了保证您的业务正常运行，请及时充值。',
    rechargeButton: '充值汇款',
    invoiceableAmount: '可开票金额',
    invoiceableAmountTip: '截止当前客户已经出账但未申请发票的账单总额。',
    invoiceButton: '去开票',
    monthlyOverview: '月度收支总览',
    chart: {
      income: '收入金额',
      expense: '支出金额',
      noData: '暂无数据',
      startMonth: '开始月份',
      endMonth: '结束月份',
    },
  },
  funds: {
    title: '收支明细',
    alert: {
      description1:
        '收支明细仅显示本资金账户的收支变动，包含充值、消费等资金增减变化；如需单独查询充值记录，可在交易类型中仅勾选充值查询。',
      description2: '收支明细不包含代金券抵扣，可访问',
      voucherManagement: '代金券管理',
      voucherDescription: '了解卡券使用详情。',
    },
  },
  invoice: {
    title: '发票管理',
    alert: {
      description1: '发票申请提交后，我们将在5个工作日内完成开票并发送至您的邮箱。',
      description2: '仅支持对已出账的账单开具发票。',
      description3: '发票金额为实际支付金额，不包含代金券抵扣部分。',
      description4: '如需修改发票信息，请联系客服处理。',
    },
    tabs: {
      issue: '开具发票',
      history: '开票历史',
      headers: '发票抬头',
      email: '接收方式',
    },
    history: {
      table: {
        applyTime: '申请时间 (UTC+8)',
        title: '发票抬头',
        invoiceType: '发票类型',
        medium: '发票介质',
        invoiceNumber: '发票号码',
        amount: '发票金额',
        comment: '备注',
        status: '状态',
        action: '操作',
        detail: '详情',
      },
      status: {
        processing: '开票中',
        completed: '已开票',
        failed: '开票失败',
      },
      pagination: {
        total: '共{{total}}条记录',
      },
    },
    issueInvoice: {
      table: {
        month: '开票月份',
        documentName: '单据名称',
        totalAmount: '发票总额',
      },
      pagination: {
        total: '共{{total}}个',
      },
      selected: '已选择 {{count}} 项，总金额：¥ {{amount}}',
      nextStep: '下一步',
    },
    invoicing: {
      title: '申请发票',
      steps: {
        selectItems: '选择开票条目',
        confirmInfo: '确认发票信息',
        complete: '完成',
      },
      customerKeyInfo: '客户关键信息',
      customerBasicInfo: '客户基本信息',
      manageTitle: '发票抬头信息管理',
      selectOtherEmail: '选择其他邮箱',
      previous: '上一步',
      submit: '提交',
      fields: {
        title: '发票抬头',
        issueType: '开具类型',
        invoiceType: '发票类型',
        amount: '开票金额',
        medium: '发票介质',
        digitalInvoice: '数码发票',
        digitalInvoiceTooltip: '数字化电子发票（简称"数电发票"）：是"全面数字化的电子发票"的简称，不以纸质形式存在，是与纸质发票具有同等法律效力的全新发票',
        receiveInfo: '接收信息',
        receiveInfoDescription: '请选择发票中需要展示的税务信息，选中后将展示在发票备注栏中的税务信息，',
        addressPhone: '购买方地址，电话',
        bankAccount: '购买方开户银行，银行账号',
        comment: '备注',
        commentPlaceholder: '如有需要，请填入',
        commentWarning: '此处填写的备注信息将在发票中显示内容区',
      },
      modals: {
        selectEmail: {
          title: '选择电子邮箱',
        },
        cancel: '取消',
        confirm: '确定',
      },
      messages: {
        emailRequired: '请选择邮箱',
        titleRequired: '请选择发票抬头',
        applySuccess: '申请成功',
      },
    },
    historyDetail: {
      title: '发票详情',
      fields: {
        title: '发票抬头',
        issueType: '开具类型',
        invoiceType: '发票类型',
        normalInvoice: '普通发票',
        vatInvoice: '增值税发票',
        amount: '开票金额',
        taxRate: '税额',
        taxRateValue: '6%',
        medium: '发票介质',
        comment: '备注',
        applyTime: '申请时间',
        taxInfo: '税务信息',
      },
    },
    headers: {
      title: '发票抬头',
      editInfo: '修改发票信息',
      noHeader: '暂无生效中的发票抬头，请点击',
      management: '发票抬头管理',
      toSetup: '进行设置',
      fields: {
        issueType: '开具类型',
        company: '企业',
        personal: '个人',
        title: '发票抬头',
        invoiceType: '发票类型',
        normalVAT: '增值税普通发票',
        specialVAT: '增值税专用发票',
        taxNumber: '纳税人识别号',
        bankName: '开户银行名称',
        bankAccount: '开户银行账号',
        address: '注册场所地址',
        phone: '注册固定电话',
        realName: '真实姓名',
        idNumber: '身份证号',
      },
    },
    titleForm: {
      title: '发票信息',
      tooltips: {
        normalVAT: '增值税普通发票：开票对象不具备一般纳税人资质，发票不能用于进项税抵扣。',
        specialVAT: '增值税专用发票：开票对象需具备一般纳税人资质，可以进行进项税抵扣。',
      },
      rules: {
        titleRequired: '请输入发票抬头',
        taxNumberRequired: '请输入纳税人识别号',
        realNameRequired: '请输入真实姓名',
        idNumberRequired: '请输入身份证号',
      },
      placeholders: {
        title: '请输入发票抬头',
        taxNumber: '请输入纳税人识别号',
        bankName: '请输入开户银行名称',
        bankAccount: '请输入开户银行账号',
        address: '请输入注册详细地址',
        phone: '请输入注册座机电话',
        realName: '请输入真实姓名',
        idNumber: '请输入身份证号',
      },
      buttons: {
        cancel: '取消',
        confirm: '确定',
      },
      messages: {
        updateSuccess: '发票信息更新成功',
      },
    },
    email: {
      title: '电子邮箱',
      addEmail: '添加电子邮箱',
      maxLimit: '您最多可添加50个电子邮箱',
      table: {
        email: '电子邮箱',
        defaultEmail: '默认邮箱',
        action: '操作',
        setDefault: '设为默认',
        edit: '修改',
        delete: '删除',
      },
      messages: {
        setDefaultSuccess: '设置默认邮箱成功',
        setDefaultFailed: '设置默认邮箱失败',
        addSuccess: '添加邮箱成功',
        addFailed: '添加邮箱失败',
        editSuccess: '修改邮箱成功',
        editFailed: '修改邮箱失败',
        deleteSuccess: '删除邮箱成功',
        deleteFailed: '删除邮箱失败',
      },
      modals: {
        addTitle: '添加电子邮箱',
        editTitle: '修改电子邮箱',
        deleteTitle: '信息提示',
        emailLabel: '电子邮箱',
        emailRequired: '请输入电子邮箱',
        emailInvalid: '请输入有效的邮箱地址',
        emailPlaceholder: '请输入邮箱地址',
        isDefault: '是否默认',
        cancel: '取消',
        confirm: '确定',
        confirmDelete: '确定删除',
        deleteConfirm: '确认要删除以下电子邮箱吗？',
      },
    },
    adminInvoiceDetail: {
      title: '发票管理/发票详情',
      detailTitle: '开票明细',
      exportButton: '导出明细',
      fields: {
        title: '发票抬头',
        issueType: '开具类型',
        invoiceType: '发票类型',
        normalInvoice: '普通发票',
        vatInvoice: '增值税发票',
        amount: '开票金额',
        taxRate: '税额',
        taxRateValue: '6%',
        medium: '发票介质',
        onlineInvoice: '数电发票',
        paperInvoice: '纸质发票',
        comment: '备注',
        applyTime: '申请时间',
        taxInfo: '税务信息',
      },
      table: {
        servicePeriod: '服务账期',
        productName: '产品名称',
        productType: '产品类型',
        consumeTime: '消费时间 (UTC+8)',
        tradeTime: '交易时间 (UTC+8)',
        orderId: '订单号',
        billKind: '账单类型',
        amount: '可开票金额',
      },
      pagination: {
        total: '共 {{total}} 条',
      },
      messages: {
        fetchDetailError: '获取发票详情失败',
        fetchListError: '获取发票明细失败',
        exportSuccess: '导出成功',
        exportError: '导出失败，请稍后重试',
      },
    },
    adminInvoiceManagement: {
      title: '发票管理',
      alert: {
        description1: '管理员在收到用户的开票申请时，请核对相关信息，信息无误后给用户开票。',
        description2: '管理员在完成【实际开票→发送邮件】后，可点击【开票】操作，填写发票号码，标记【已开票】。',
        description3: '如信息有误请填写原因后进行【拒绝】操作。',
        description4: '所有申请需在 72 小时内 处理完毕【含开票/拒绝】',
      },
      filters: {
        category: '开具类型',
        invoiceType: '发票类型',
        status: '发票状态',
        placeholder: '请选择',
      },
      table: {
        applyTime: '申请时间 (UTC+8)',
        title: '发票抬头',
        category: '开具类型',
        invoiceType: '发票类型',
        medium: '发票介质',
        amount: '开票金额',
        status: '状态',
        operator: '操作人',
        operateTime: '操作时间',
        action: '操作',
        detail: '详情',
        approve: '开票',
        reject: '拒绝',
      },
      status: {
        processing: '待开票',
        completed: '已开票',
        failed: '开票失败',
      },
      pagination: {
        total: '共{{total}}条记录',
      },
      modals: {
        confirm: '确定',
        cancel: '取消',
        approve: {
          title: '开票操作',
          invoiceNumber: '发票号码',
          invoiceNumberRequired: '请输入发票号码',
          invoiceNumberPlaceholder: '请填写',
        },
        reject: {
          title: '拒绝开票',
          rejectReason: '拒绝原因:',
          rejectReasonRequired: '请输入拒绝原因',
          rejectReasonPlaceholder: '请填写拒绝原因',
        },
      },
      messages: {
        approveSuccess: '开票操作成功',
        approveError: '开票操作失败',
        rejectSuccess: '拒绝操作成功',
        rejectError: '拒绝操作失败',
      },
    },
  },
  billOverview: {
    amount: {
      payable: '应付金额',
      actual: '实付金额',
    },
    orderDetail: '订单明细',
    payOrder: '支付订单',
    resourceType: {
      ecs: '虚拟机',
      baremetal: '裸金属',
      disk: '硬盘',
    },
    table: {
      productName: '产品名称',
      productType: '产品类型',
      region: '可用地区',
      cluster: '资源集群',
      duration: '购买时长',
      durationHourly: '小时',
      durationMonthly: '个月',
      durationAnnual: '年',
      quantity: '购买数量',
      timeRange: '起止时间',
      originalPrice: '官网目录价',
      discountedPrice: '官网折扣价',
      couponDiscount: '代金券抵扣',
      payableAmount: '应付金额',
      actualAmount: '实付金额',
      modelUnit: '/百万 tokens',
    },
  },
  history: {
    title: '充值历史',
    alert: {
      description:
        '充值历史包含充值成功、充值失败、待支付、已取消的充值历史记录，只有充值成功的记录才会在收支明细中体现。',
    },
    table: {
      account: '账户',
      rechargeId: '充值ID',
      paymentMethod: '支付方式',
      rechargeAccount: '充值帐户',
      action: '操作',
      detail: '详情',
      pay: '支付',
      cancel: '取消',
    },
    paymentMethod: {
      ALIPAY: '支付宝',
      INTERNAL: '余额支付',
      EXTERNAL: '余额充值',
    },
    modal: {
      confirmCancel: '确认取消',
      confirmCancelContent: '确认取消充值订单？',
      cancelSuccess: '订单已取消',
      cancelFailed: '取消订单失败，请重试',
      payFailed: '支付失败，请重试',
    },
  },
  bills: {
    table: {
      productName: '产品名称',
      productId: '产品ID',
      originalPrice: '官网目录价',
      discountedPrice: '官网折扣价',
      couponDiscount: '代金券抵扣',
      payableAmount: '应付金额',
      detail: '详情',
      pay: '支付',
      cancel: '取消',
    },
    modal: {
      title: '支付订单 {id}',
      payableAmount: '应付金额',
      orderType: '订单类型',
      confirmCancel: '确认取消',
      confirmCancelContent: '确认取消充值订单？',
      cancelSuccess: '订单已取消',
      cancelFailed: '取消订单失败，请重试',
    },
  },
  orderFilter: {
    createTimeRange: '创建时间范围',
    productName: '产品名称',
    orderStatus: '订单状态',
    orderType: '订单类型',
    allOrderStatus: '所有订单状态',
    allOrderType: '所有订单类型',
    inputProductName: '请输入产品名称',
    selectOrderStatus: '请选择订单状态',
    selectOrderType: '请选择订单类型',
  },
  billReport: {
    title: '账单概览',
    alert: {
      description1:
        '当月数据查询结果仅供参考，不作为对账依据；当月最终账单在次月2日12点后支持查看/导出。',
      description2: '出具账单后，按照出账先后顺序进行扣款。',
      description3: '优先抵扣代金券，超出部分使用账户余额抵扣。',
      description4: '用户充值后，默认按照出账先后顺序，进行未结清账单还款。',
    },
    tabs: {
      monthlyOverview: '月度账单概览',
      monthlyHistory: '月度账单历史',
    },
  },
  monthlyBillOverview: {
    title: '月度账单概览',
    monthSelector: '账单月份：',
    overview: '月度概览',
    overviewTitle: '月概览',
    billingCycle: '账单周期：',
    to: '至',
    status: {
      billed: '已出账',
      pending: '出账中',
    },
    exportBill: '导出账单',
    exportSuccess: '导出成功',
    exportError: '导出失败，请稍后重试',
    payableAmount: '应付金额',
    tabs: {
      accountSummary: '按资源购买账号汇总',
      productSummary: '按产品汇总',
    },
    table: {
      resourcePurchaseAccount: '资源购买账号',
      billingPeriod: '账务账期',
      catalogTotalPrice: '目录总价（原价）',
      discountedPrice: '折后价',
      voucherDeduction: '代金券抵扣',
      payableAmount: '应付金额',
      productType: '产品类型',
      billingMode: '计费模式',
      feeType: '费用类型',
      prepaid: '预付费',
      postpaid: '后付费',
    },
  },
  monthlyBillHistory: {
    title: '月度账单历史',
    billingPeriod: '账务账期：',
    resourcePurchaseAccount: '资源购买账号：',
    dateRangePlaceholder: {
      startMonth: '开始月份',
      endMonth: '结束月份',
    },
    maxQueryWarning: '最多查询12个月的数据',
    table: {
      resourcePurchaseAccount: '资源购买账号',
      billingPeriod: '账务账期',
      catalogTotalPrice: '目录总价（原价）',
      discountedPrice: '折后价',
      voucherDeduction: '代金券抵扣',
      payableAmount: '应付金额',
      status: '状态',
      action: '操作',
      detail: '详情',
    },
    status: {
      billed: '已出账',
      pending: '出账中',
    },
    pagination: {
      total: '共 {total} 条',
    },
  },
  accountSelector: {
    placeholder: '请选择资源购买账号',
    all: '全部',
  },
  billCycle: {
    title: '账单详情',
    alert: {
      description1:
        '当月数据查询结果仅供参考，不作为对账依据；当月最终账单在次月2日12点后支持查看/导出。',
      description2: '已出账的账单支持开发票。',
    },
    tabs: {
      orderDetail: '订单出账明细',
      billDetail: '账单明细',
    },
  },
  orderMonthlyDetail: {
    title: '订单月度明细',
    filters: {
      billingPeriod: '账务账期：',
      resourcePurchaseAccount: '资源购买账号：',
      orderId: '订单号：',
      hideZeroBills: '隐藏0元账单',
      dateFormat: 'YYYY年M月',
    },
    placeholders: {
      selectAccount: '请选择资源购买账号',
      enterOrderId: '请输入订单号',
    },
    table: {
      resourcePurchaseAccount: '资源购买账号',
      orderId: '订单号',
      productName: '产品名称',
      productType: '产品类型',
      billingCycle: '计费周期',
      billStartTime: '账单开始时间',
      billEndTime: '账单结束时间',
      tradeTime: '交易时间',
      catalogTotalPrice: '目录总价（原价）',
      discountedPrice: '折后价',
      voucherDeduction: '代金券抵扣',
      payableAmount: '应付金额',
    },
  },
  billMonthlyDetail: {
    title: '账单月度明细',
    filters: {
      billingPeriod: '账务账期：',
      resourcePurchaseAccount: '资源购买账号：',
      project: '项目：',
      instanceId: '实例ID：',
      dateFormat: 'YYYY年M月',
    },
    placeholders: {
      selectAccount: '请选择资源购买账号',
      enterInstanceId: '请输入实例ID',
    },
    table: {
      resourcePurchaseAccount: '资源购买账号',
      productType: '产品类型',
      billingMode: '计费模式',
      orderType: '订单类型',
      usageDuration: '使用时长',
      durationUnit: '时长单位',
      instanceId: '实例ID',
      project: '项目',
      availableRegion: '可用地区',
      resourceCluster: '资源集群',
      unitPrice: '单价',
      usageQuantity: '用量',
      usageUnit: '用量单位',
      catalogTotalPrice: '目录总价（原价）',
      discountedPrice: '折后价',
      voucherDeduction: '代金券抵扣',
      payableAmount: '应付金额',
    },
    billingMode: {
      prepaid: '预付费',
      postpaid: '后付费',
    },
    durationUnits: {
      month: '月',
      second: '秒',
      year: '年',
      hour: '时',
    },
    messages: {
      fetchDataError: '获取数据失败，请重试',
    },
  },
  workspaceSelector: {
    all: '全部',
    placeholder: '请选择工作空间',
  },
  costReport: {
    title: '成本报告',
    monthlyCostTrend: '月度成本趋势',
    summary: '汇总',
    costDetails: '成本明细',
    tabs: {
      byResourceType: '按资源类型',
      byProject: '按项目',
      byBillingMode: '按计费模式',
      byRegion: '按区域',
    },
    datePicker: {
      monthFormat: 'YYYY-MM',
      rangePickerPlaceholder: ['开始月份', '结束月份'],
    },
    charts: {
      noData: '暂无数据',
      costAmount: '成本金额',
      tooltip: {
        percentage: '%',
        currency: '¥',
      },
      monthlyCostTrend: {
        month: '月',
        cost: '成本',
        tooltip: {
          cost: '成本',
        },
      },
    },
  },
  usageManagement: {
    title: '用量管理',
    alert: {
      description1: '用量数据每小时更新一次，可能存在1-2小时的延迟。',
      description2: '当月数据查询结果仅供参考，不作为对账依据。',
      description3: '当月最终用量数据在次月2日12点后支持查看。',
    },
    tabs: {
      compute: '计算资源用量分析',
      storage: '存储资源用量分析',
      task: '任务负载明细',
    },
    compute: {
      title: '计算资源用量分析',
      resourceDurationTrend: '资源总时长趋势统计',
      durationSummary: '时长汇总',
      instanceSpec: '实例规格',
      project: '项目',
      availableRegion: '可用地区',
      top: 'TOP',
      selectInstanceSpec: '请选择实例规格',
      selectRegion: '请选择区域',
      selectProject: '请选择项目',
      all: '全部',
      hours: '小时',
      percentage: '%',
      byInstanceSpec: '按实例规格',
      byProject: '按项目',
      byAvailableZone: '按可用区',
      byTaskSubmitter: '按任务提交者',
      byTaskType: '按任务类型',
      name: '名称',
      usageDuration: '使用时长',
      ratio: '比例',
      prepaidUsageDuration: '预付费使用时长',
      postpaidUsageDuration: '后付费使用时长',
      cardHours: '卡时',
      aiResources: 'AI资源',
      virtualMachine: '虚拟机',
      bareMetal: '裸机',
    },
    storage: {
      title: '存储资源用量分析',
      storageResourceTrend: '存储资源统计趋势',
      storageTotalCapacityTrend: '存储总容量趋势图',
      unit: 'GiB * 月',
      selectRegion: '请选择区域',
      all: '全部',
      project: '项目',
      availableRegion: '可用地区',
      totalCapacity: '总容量',
      unitLabel: '单位',
      month: '月',
    },
    task: {
      title: '任务负载明细',
      taskId: '任务ID',
      taskType: '任务类型',
      resourceSpec: '资源规格',
      specCount: '规格数量',
      resourceType: '资源类型',
      createTime: '创建时间',
      startTime: '开始运行时间',
      endTime: '结束时间',
      project: '项目',
      availableRegion: '可用地区',
      resourceCluster: '资源集群',
      creator: '创建人',
      trainTask: '训练任务',
      containerInstance: '容器实例',
      inferenceService: '推理服务',
      prepaid: '预付费',
      postpaid: '后付费',
      fetchDataError: '获取任务负载数据失败',
    },
    filter: {
      createTimeRange: '创建时间范围',
      taskType: '任务类型',
      taskId: '任务ID',
      creator: '创建人',
      projectName: '项目名称',
      inputTaskType: '请输入任务类型',
      inputTaskId: '请输入任务ID',
      inputCreator: '请选择创建人',
      inputProjectName: '请选择项目',
    },
  },
}

export default translation
